import { INBOX_TYPES } from 'dashboard/helper/inbox';

// Post types each supported channel can publish through - the key set doubles as the list
// of inbox channel types the Social Media Posts feature supports.
export const CHANNEL_POST_TYPES = {
  [INBOX_TYPES.FB]: ['facebook_post', 'facebook_reel'],
  [INBOX_TYPES.INSTAGRAM]: ['instagram_post'],
  [INBOX_TYPES.TIKTOK]: ['tiktok_post'],
};

export const isSupportedInbox = inbox =>
  Boolean(CHANNEL_POST_TYPES[inbox.channel_type]);

export const CHANNEL_TYPE_LABEL_KEYS = {
  [INBOX_TYPES.FB]: 'WGPT_SOCIAL_MEDIA_POSTS.CHANNEL_TYPES.FACEBOOK',
  [INBOX_TYPES.INSTAGRAM]: 'WGPT_SOCIAL_MEDIA_POSTS.CHANNEL_TYPES.INSTAGRAM',
  [INBOX_TYPES.TIKTOK]: 'WGPT_SOCIAL_MEDIA_POSTS.CHANNEL_TYPES.TIKTOK',
};

export const channelTypeLabelKey = channelType =>
  CHANNEL_TYPE_LABEL_KEYS[channelType];

// Inverse of CHANNEL_POST_TYPES - resolves the channel type a post publishes through,
// so channel branding survives even after the inbox itself is deleted.
export const postChannelType = post =>
  Object.keys(CHANNEL_POST_TYPES).find(channelType =>
    CHANNEL_POST_TYPES[channelType].includes(post.post_type)
  );

export const isReelPost = post => Boolean(post.post_type?.endsWith('reel'));

export const postTypeLabelKey = post =>
  isReelPost(post)
    ? 'WGPT_SOCIAL_MEDIA_POSTS.POST_TYPE.REEL'
    : 'WGPT_SOCIAL_MEDIA_POSTS.POST_TYPE.POST';

export const postTypeIcon = post =>
  isReelPost(post) ? 'i-lucide-clapperboard' : 'i-lucide-image';

export const POST_STATUS_TEXT_COLORS = {
  published: 'text-n-teal-11',
  failed: 'text-n-ruby-11',
  removal_requested: 'text-n-slate-11',
  removed: 'text-n-slate-11',
  pending: 'text-n-amber-11',
  processing: 'text-n-amber-11',
};

export const POST_STATUS_LABEL_KEYS = {
  pending: 'WGPT_SOCIAL_MEDIA_POSTS.STATUS.PENDING',
  processing: 'WGPT_SOCIAL_MEDIA_POSTS.STATUS.PROCESSING',
  published: 'WGPT_SOCIAL_MEDIA_POSTS.STATUS.PUBLISHED',
  failed: 'WGPT_SOCIAL_MEDIA_POSTS.STATUS.FAILED',
  removal_requested: 'WGPT_SOCIAL_MEDIA_POSTS.STATUS.REMOVAL_REQUESTED',
  removed: 'WGPT_SOCIAL_MEDIA_POSTS.STATUS.REMOVED',
};

export const postStatusTextColor = status =>
  POST_STATUS_TEXT_COLORS[status] || POST_STATUS_TEXT_COLORS.pending;

export const postStatusLabelKey = status =>
  POST_STATUS_LABEL_KEYS[status] || POST_STATUS_LABEL_KEYS.pending;

// The card payload carries a single cover_media + media_count; the full payload carries
// every attachment in media_items - support both shapes.
export const postCoverMedia = post =>
  post.cover_media || post.media_items?.[0] || null;

export const postMediaCount = post =>
  post.media_count ?? post.media_items?.length ?? 0;

// Only published Facebook posts can be removed - mirrors WgptSocialMediaPost#removable?.
export const isPostRemovable = post =>
  post.status === 'published' &&
  ['facebook_post', 'facebook_reel'].includes(post.post_type);
